import {
  ReconciliationFilled,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { CustomLabel } from "../../../utilities/utll";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";
const initial = {
  division: null,
  divisionName: null,
  department: null,
  departmentName: null,
  expiryDiscount: null,
  nearExpiryDiscount: null,
};

export const FormSection = ({
  editData,
  onChange,
  resetTrigger,
  errors,
  resetKey,
}) => {
  const [formData, setFormData] = useState(initial);
  const { expiryDiscount, getExpiryDiscountById } = useNearToExpiryStore();
  const { getDepartment, department, getCategory, category } =
    useVendorMasterStore();

  useEffect(() => {
    getCategory();
  }, []);
  useEffect(() => {
    setFormData(initial);
  }, [resetKey]);

  useEffect(() => {
    if (editData?.Id) {
      getExpiryDiscountById(editData.Id);
    }
  }, [editData?.Id]);
  useEffect(() => {
    if (!editData?.Id) return;
    if (!expiryDiscount || expiryDiscount.length === 0) return;

    const row = expiryDiscount[0];

    const updated = {
      division: row.DivisionCode,
      divisionName: row.DivisionName || null,
      department: row.DepartmentCode,
      departmentName: row.DepartmentName || null,
      expiryDiscount: row.Discount1,
      nearExpiryDiscount: row.Discount2,
    };

    setFormData(updated);
    onChange?.(updated);
  }, [expiryDiscount]);
  useEffect(() => {
    if (!formData.division || category.length === 0) return;

    const divisionObj = category.find(
      (c) => String(c.Division) === String(formData.division),
    );

    if (divisionObj) {
      setFormData((prev) => ({
        ...prev,
        divisionName: divisionObj.DivisionName,
      }));
      onChange?.({
        ...formData,
        divisionName: divisionObj.DivisionName,
      });
    }

    getDepartment(formData.division);
  }, [formData.division, category]);
  useEffect(() => {
    if (!formData.department || department.length === 0) return;

    const deptObj = department.find(
      (d) => String(d.Department) === String(formData.department),
    );

    if (deptObj) {
      setFormData((prev) => ({
        ...prev,
        departmentName: deptObj.DepartmentName,
      }));
      onChange?.({
        ...formData,
        departmentName: deptObj.DepartmentName,
      });
    }
  }, [formData.department, department]);

  useEffect(() => {
    if (resetTrigger) {
      setFormData(initial);
    }
  }, [resetTrigger]);
  const handleInputChange = (field, value) => {
    const updated = { ...formData, [field]: value };
    setFormData(updated);
    onChange?.(updated);
  };

  return (
    <>
      <div className="tab-content">
        <Row>
          <Col xl={3} md={6}>
            <CustomLabel children={"Divison"} isImportnt={false} />
            <Select
              id="roletype"
              placeholder="Select "
              allowClear
              showSearch
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              value={formData.division}
              options={category.map((c) => ({
                label: c.DivisionName,
                value: c.Division,
              }))}
              onChange={(value) => {
                const updated = {
                  ...formData,
                  division: value || null,
                  divisionName:
                    category.find((c) => c.Division === value)?.DivisionName ||
                    null,
                  department: null,
                  departmentName: null,
                };
                setFormData(updated);
                onChange?.(updated);
                if (value) getDepartment(value);
              }}
            />
            {errors?.division && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.division}
              </span>
            )}
          </Col>
          <Col xl={3} md={6}>
            <CustomLabel children={"Department"} isImportnt={false} />
            <Select
              id="roletype"
              placeholder="Select "
              allowClear
              showSearch
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              value={formData.department}
              options={department.map((d) => ({
                label: d.DepartmentName,
                value: d.Department,
              }))}
              onChange={(value) => {
                const updated = {
                  ...formData,
                  department: value || null,
                  departmentName:
                    department.find((d) => d.Department === value)
                      ?.DepartmentName || null,
                };
                setFormData(updated);
                onChange?.(updated);
              }}
            />
            {errors?.department && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.department}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"Expiry Discount"} isImportnt={false} />
            <Input
              name="Expiry Discount"
              id="ExpiryDiscount"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={formData.expiryDiscount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  handleInputChange("expiryDiscount", Number(value));
                }
              }}
            />
            {errors?.expiryDiscount && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.expiryDiscount}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"Near Expiry Discount"} isImportnt={false} />
            <Input
              name="Near Expiry Discount"
              id="nearExpiryDiscount"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={formData.nearExpiryDiscount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  handleInputChange("nearExpiryDiscount", Number(value));
                }
              }}
            />
            {errors?.nearExpiryDiscount && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.nearExpiryDiscount}
              </span>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
